/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Submit_ButtonInputs */

const sv_form_submit_button = /** @type {(inputs: Form_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka formulär`)
};

const en_form_submit_button = /** @type {(inputs: Form_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit form`)
};

/**
* | output |
* | --- |
* | "Submit form" |
*
* @param {Form_Submit_ButtonInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const form_submit_button = /** @type {((inputs?: Form_Submit_ButtonInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Submit_ButtonInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_form_submit_button(inputs)
	return en_form_submit_button(inputs)
});